import React, { useState, useEffect } from 'react'
import { Spin, Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import coreReducer from '../../../../core/utils/reducer'
import CoreEnums from '../../../../core/utils/enums'
import EditPatientProfile from '../../../Admin/system-users/components/patient/EditPatient'
import systemUsersReducer from '../../../Admin/system-users/utils/reducer'
import store from '../../../../store'

const PatientFileViewer = ({ initialTab = null }) => {
  const authState = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Get the current patient's data from auth state
  const currentPatientData = authState.agiliteUser
  const currentPatientId = currentPatientData?._id

  useEffect(() => {
    const loadPatientToActiveRecords = () => {
      console.log('=== PATIENT FILE VIEWER LOADING ===')
      console.log('Current patient data:', currentPatientData)
      console.log('Current patient ID:', currentPatientId)

      if (!currentPatientData || !currentPatientId) {
        setError('Unable to determine your patient information. Please log in again.')
        setLoading(false)
        return
      }

      if (currentPatientData.extraData?.role?.type !== 'patient') {
        setError('This feature is only available for patient accounts.')
        setLoading(false)
        return
      }

      try {
        // Get current active records from Redux store
        const activeRecords = store.getState().systemUsers.activeRecords
        const tmpActiveRecords = [...activeRecords]

        // Check if patient data already exists in activeRecords
        const recordIndex = tmpActiveRecords.findIndex((item) => item._id === currentPatientId)

        // If record doesn't exist, add it to activeRecords
        if (recordIndex === -1) {
          tmpActiveRecords.push(currentPatientData)
          console.log('Added current patient data to activeRecords')
        } else {
          // Update the record if it already exists
          tmpActiveRecords[recordIndex] = currentPatientData
          console.log('Updated existing patient data in activeRecords')
        }

        // Update activeRecords in Redux store
        dispatch(systemUsersReducer.actions.setActiveRecords(tmpActiveRecords))

        console.log('Successfully loaded patient data from auth state')
        setLoading(false)
      } catch (error) {
        console.error('Error setting up patient data:', error)
        setError('Failed to load your patient information.')
        setLoading(false)
      }
    }

    loadPatientToActiveRecords()
  }, [currentPatientData, currentPatientId, dispatch])

  const handleBackToLanding = () => {
    // Close this tab and go back to the landing page
    dispatch(coreReducer.actions.closeTab({ targetKey: `${CoreEnums.tabKeys.MY_PATIENT_FILE}_viewer` }))

    // Ensure the landing page tab is active
    dispatch(
      coreReducer.actions.changeTab({
        activeKey: CoreEnums.tabKeys.MY_PATIENT_FILE
      })
    )
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size='large' />
        <div style={{ marginTop: '16px' }}>Loading your patient file...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h3>Unable to Load Patient File</h3>
        <p>{error}</p>
        <div style={{ marginTop: '20px' }}>
          <Button type='primary' onClick={handleBackToLanding}>
            <ArrowLeftOutlined />
            Back to My Patient File
          </Button>
        </div>
      </div>
    )
  }

  if (!currentPatientData) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h3>Patient Data Not Available</h3>
        <p>Please log in to view your patient file.</p>
        <div style={{ marginTop: '20px' }}>
          <Button type='primary' onClick={handleBackToLanding}>
            <ArrowLeftOutlined />
            Back to My Patient File
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Patient Profile Component */}
      <EditPatientProfile
        dataId={currentPatientId}
        refreshView={handleBackToLanding}
        handleRootTabKey={() => CoreEnums.tabKeys.MY_PATIENT_FILE}
        isDependant={false}
        isExamination={false}
        isNew={false}
        initialTab={initialTab}
      />
    </div>
  )
}

export default PatientFileViewer
